export class Sorter<D> {
   public sort(array: D[], scheme: SortScheme<D>): D[] {
      const { leader, chain, toState } = scheme;
      const sorted = this.chainSorting(array, [leader, ...chain], toState);

      return sorted;
   }

   public getNextSortState(state: SortState): SortState {
      let nextState: SortState;
      switch (state) {
         case 'none': nextState = 'desc'; break;
         case 'desc': nextState = 'asc'; break;
         case 'asc': nextState = 'desc'; break;
      }

      return nextState;
   }

   private chainSorting(array: D[], chain: Sortable<D>[], toState: SortState): D[] {
      const groups: RowGroups<D> = {};
      const sortedGroups: D[] = [];
      const sortable = chain[0];

      if (sortable) {
         array.forEach(val => {
            const value = sortable.getter(val);
            groups[value] = groups[value] || [];
            groups[value].push(val);
         });

         for (const id in groups) {
            const group = groups[id];
            let sortedGroup: D[];

            if (group.length > 1) {
               sortedGroup = this.chainSorting(group, chain.slice(1), 'asc');
            } else {
               sortedGroup = group;
            }

            sortedGroups.push(...sortedGroup);
         }

         return this.sorting(sortable, sortedGroups, toState);
      } else {
         return array;
      }
   }


   private sorting(sortable: Sortable<D>, array: D[], toState: SortState): D[] {
      const { sorter } = sortable;

      switch (toState) {
         case 'asc': array.sort((a, b) => sorter(a, b)); break;
         case 'desc': array.sort((a, b) => sorter(b, a)); break;
         default: console.error(`Unknown sort state: ${toState}`);
      }

      return array;
   }
}

// =========================
//          Models
// =========================

export type SortState = 'none' | 'asc' | 'desc';
export type SorterFn<D> = (a: D, b: D) => number;

export interface SortableArgs<D> {
   id: string;
   sorter: SorterFn<D>;
   getter: (val: D) => string;
   defaults: SortState;
   isActive: boolean;
}

export class Sortable<D> implements SortableArgs<D> {
   readonly id: string;
   public state: SortState;
   readonly defaults: SortState;
   readonly sorter: SorterFn<D>;
   readonly getter: (val: D) => string;
   readonly isActive: boolean;

   constructor({ id, sorter, getter, defaults, isActive }) {
      this.id = id;
      this.state = this.defaults = defaults;
      this.getter = getter;
      this.sorter = sorter;
      this.isActive = isActive;
   }
}



interface RowGroups<D> {
   [groupId: string]: D[];
}

export interface SortScheme<D> {
   toState: SortState;
   leader: Sortable<D>;
   chain: Sortable<D>[];
};